import { Chip } from "@artprov/design-system";
import { useMatchingBancarioFiltersStore } from "../zustand/filters.store.js";
import { useFilterOptions } from "../hooks/useFilterOptions.js";

export default function TagsFilters() {
    const { banco, fechaDesde, fechaHasta, fechaEstadoDesde, fechaEstadoHasta, estado } = useMatchingBancarioFiltersStore((state) => state.filters);
    const clearFilter = useMatchingBancarioFiltersStore((state) => state.clearFilter);

    // Cargar opciones de filtros (bancos y estados) desde hook centralizado
    const { getBancoLabel, getEstadoLabel } = useFilterOptions();

    // Construir objeto de filtros aplicados
    const appliedFilters = {};
    if (banco) appliedFilters.banco = banco;
    if (fechaDesde) appliedFilters.fechaDesde = fechaDesde;
    if (fechaHasta) appliedFilters.fechaHasta = fechaHasta;
    if (fechaEstadoDesde) appliedFilters.fechaEstadoDesde = fechaEstadoDesde;
    if (fechaEstadoHasta) appliedFilters.fechaEstadoHasta = fechaEstadoHasta;
    if (estado) appliedFilters.estado = estado;

    const entries = Object.entries(appliedFilters).filter(([, value]) => value && value !== "");

    if (!entries.length) return null;

    const filterLabels = {
        banco: "Banco",
        fechaDesde: "Fecha mail desde",
        fechaHasta: "Fecha mail hasta",
        fechaEstadoDesde: "Fecha estado desde",
        fechaEstadoHasta: "Fecha estado hasta",
        estado: "Estado",
    };

    const handleRemove = (key) => {
        clearFilter(key);
    };

    const getLabelForFilter = (key, value) => {
        const label = filterLabels[key];

        // Formatear fechas
        if (key === "fechaDesde" || key === "fechaHasta" || key === "fechaEstadoDesde" || key === "fechaEstadoHasta") {
            const [year, month, day] = value.split('-');
            const formattedDate = `${day}/${month}/${year}`;
            return `${label}: ${formattedDate}`;
        }

        // Convertir ID de banco a nombre
        if (key === "banco") {
            return `${label}: ${getBancoLabel(value)}`;
        }

        // Convertir ID de estado a label
        if (key === "estado") {
            return `${label}: ${getEstadoLabel(value)}`;
        }

        return `${label}: ${value}`;
    };

    return (
        <div className="flex flex-wrap gap-2">
            {entries.map(([key, value]) => (
                <Chip
                    key={`chip-${key}`}
                    label={getLabelForFilter(key, value)}
                    variant="primary"
                    onClose={() => handleRemove(key)}
                />
            ))}
        </div>
    );
}
